import React, { useContext } from "react";
import { Container, useMediaQuery } from "@mui/material";
import { AuthenticationContext } from "../authentication/AuthenticationContext";
import { faCaretDown, faGear, faGroupArrowsRotate, faHistory, faHome, faMusic, faSignOut, faSortAmountAsc, faTable, faTools } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import theme from "../../theme";
import noizillaLogo from '../../assets/Noizilla-name-logo.png';
import './nav-bar.scss';

const NavBar = () => {
  const { isAuthenticated, logout } = useContext(AuthenticationContext);
  const isSmall = useMediaQuery((theme) => theme.breakpoints.up('sm'));

  return (
    <div className="navbar">
      <Container>
        {isAuthenticated() &&
          <>
            <a href="/#/">
              <FontAwesomeIcon fontSize="small" icon={faHome} /> Home
            </a>
            <a href="/#/play/nowplaying">
              <FontAwesomeIcon fontSize="small" icon={faMusic} /> Now Playing
            </a>
            <a href="/#/genres">
              <FontAwesomeIcon fontSize="small" icon={faGroupArrowsRotate} /> Genres
            </a>
            <a href="/#/queue">
              <FontAwesomeIcon fontSize="small" icon={faSortAmountAsc} /> Queue
            </a>
            <a href="/#/settings">
              <FontAwesomeIcon fontSize="small" icon={faTools} /> Settings
            </a>
            <a href="/#/admin">
              <FontAwesomeIcon fontSize="small" icon={faGear} /> Admin
            </a>
            <div className="dropdown">
              <button className="dropbtn">Analytics <FontAwesomeIcon fontSize="small" icon={faCaretDown} /></button>
              <div className="dropdown-content">
                <a href="/#/recentTracks">
                  <FontAwesomeIcon fontSize="small" icon={faHistory} /> Recent History
                </a>
                <a href="/#/analytics">
                  <FontAwesomeIcon fontSize="small" icon={faTable} /> Analytics
                </a>
              </div>
            </div>
            <button
              type="button"
              className="nav-action"
              onClick={logout}
              style={{ color: theme.palette.warning.main }}
            >
              <FontAwesomeIcon fontSize="small" icon={faSignOut} /> Logout
            </button>
          </>
        }
        {isSmall &&
          <img
            src={noizillaLogo}
            alt="chr-logo"
            style={{
              maxHeight: '42px',
              paddingTop: '0.5rem',
              float: 'right'
            }}
          />
        }
      </Container>
    </div>
  );
};

export default NavBar;